import React, { useRef } from 'react';
import { Input, Icon, Button, Box, Flex } from '@chakra-ui/react';
import { GrAttachment, GrClose } from 'react-icons/gr';
import { useFormikContext } from 'formik';
export var UploadSlip = function UploadSlip(props) {
  var _a = React.useState(''),
      fileName = _a[0],
      setFileName = _a[1];

  var name = props.name;
  var setFieldValue = useFormikContext().setFieldValue;
  var $inputRef = useRef(null);

  var onChange = function onChange(e) {
    var file = e.target.files[0];
    setFileName(file.name);
    setFieldValue(name, file);
  };

  var onOpenFileDialog = function onOpenFileDialog() {
    if ($inputRef && $inputRef.current) {
      $inputRef.current.value = '';
      $inputRef.current.click();
    }
  };

  var onClickClear = function onClickClear() {
    setFileName('');
    setFieldValue(name, null);
  };

  if (fileName) {
    return /*#__PURE__*/React.createElement(Flex, {
      alignItems: "center",
      pt: "2",
      pb: "2"
    }, /*#__PURE__*/React.createElement(Icon, {
      as: GrAttachment,
      boxSize: "14px",
      mr: "2"
    }), /*#__PURE__*/React.createElement(Box, {
      mr: "2"
    }, fileName), /*#__PURE__*/React.createElement(Box, {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      userSelect: "none",
      p: "5px 4px 2px",
      borderRadius: "4px",
      onClick: onClickClear
    }, /*#__PURE__*/React.createElement(Icon, {
      as: GrClose,
      boxSize: "10px",
      color: "red.400"
    })));
  }

  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Input, {
    ref: $inputRef,
    accept: "image/*",
    type: "file",
    autoComplete: "off",
    tabIndex: -1,
    display: "none",
    onChange: onChange
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: onOpenFileDialog,
    colorScheme: "brand"
  }, "\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E"));
};